(function () {
    'use strict';

    function fileUploader($http, $compile, $window, fileUploadsService, notifyService) {
        return {
            restrict: 'E',
            scope: {
                documentUpload: '=',
                groupTitle: '=',
                user: '=',
                title: '=',
                requireUpload: '='
            },
            templateUrl: 'common/directives/templates/fileUploader.html',
            link: function (scope, element) {
                var uploader = new qq.azure.FineUploaderBasic({
                    request: { endpoint: "https://ecapwebstorage.blob.core.windows.net/uploads" },
                    signature: {
                        endpoint: "/sas?fileType=Upload",
                        customHeaders: function (id) {
                            return {
                                "guid": uploader.getGuid(id)
                            }
                        }
                    },
                    uploadSuccess: { endpoint: "/aus" },
                    chunking: {
                        enabled: true,
                        concurrent: {
                            enabled: true
                        }
                    },
                    retry: {
                        enableAuto: true
                    },
                    debug: false,
                    button: $(element).find('.file-uploader-button')[0],
                    multiple: true,
                    validation: {
                        allowedExtensions: ['pdf', 'csv', 'xlsx', 'xls', 'doc', 'docx', 'tif', 'tiff', 'ai', 'ppt', 'pptx', 'zip', 'jpg'],
                        sizeLimit: 2147483647
                    },
                    autoUpload: false,
                    deleteFile: {
                        enabled: false
                    },
                    callbacks: {
                        onComplete: function (id, fileName, responseJson) {
                            var guid = uploader.idsAndGuids[id];
                            var matchingFileUpload = _.find(fileUploadsService.fileUploads, { Guid: guid });

                            scope.documentUpload.BlobSummaries.push({
                                'FileName': fileName,
                                'BlobReference': guid,
                                'DateUploaded': new Date(),
                                'UploadedByUserName': this.user
                            });

                            this.fileUploadsService.markFileAsComplete(matchingFileUpload);
                        },
                        onUpload: function (id, fileName) {
                            fileUploadsService.markFileAsUploading(uploader.idsAndGuids[id]);
                        },
                        onSubmit: function (id, fileName) {
                            var guid = uuid.v4();
                            var size = this.getSize(id);
                            fileUploadsService.fileUploads.push(
                            {
                                'FileName': fileName,
                                'DocumentUploadTitle': this.title,
                                'DocumentUploadGroupTitle': this.groupTitle,
                                'UploaderId': id,
                                'TotalBytes': size,
                                'UploadedBytes': 0,
                                'PercentComplete': 0,
                                'Guid': guid,
                                'Status': 'submitted'
                            });
                            uploader.idsAndGuids[id] = guid;
                            scope.$apply();
                        },
                        onProgress: function (id, fileName, uploadedBytes, totalBytes) {
                            var matchingIndex = _.findIndex(fileUploadsService.fileUploads, { Guid: uploader.getGuid(id) });
                            fileUploadsService.fileUploads[matchingIndex].Status = 'uploading';
                            fileUploadsService.fileUploads[matchingIndex].UploadedBytes = uploadedBytes;
                            fileUploadsService.fileUploads[matchingIndex].PercentComplete =
                                Math.floor((fileUploadsService.fileUploads[matchingIndex].UploadedBytes /
                                    fileUploadsService.fileUploads[matchingIndex].TotalBytes) * 100);
                        },
                        onError: function (id, name, reason, xhr) {
                            if (reason === 'No files to upload.') {
                                // do nothing
                            }
                            else {
                                notifyService.notify(reason, true);
                            }
                        }
                    }
                });

                uploader.idsAndGuids = {};
                uploader.getGuid = function (id) {
                    return uploader.idsAndGuids[id.toString().split('.')[0]];
                }
                uploader.user = scope.user;
                uploader.title = scope.title;
                uploader.groupTitle = scope.groupTitle;
                uploader.fileUploadsService = fileUploadsService;
                fileUploadsService.addUploader(uploader);

            }
        };
    }

    fileUploader.$inject = ['$http', '$compile', '$window', 'fileUploadsService', 'notifyService'];

    angular.module('ecap.common').directive('fileUploader', fileUploader);
})();
